import { useEffect, useRef } from 'react';

export const useLockScroll = (open: boolean, lockScroll?: boolean) => {
    const htmlElementRef = useRef(document.querySelector('html'));

    useEffect(() => {
        const { current: htmlElement } = htmlElementRef;

        if (!lockScroll || !htmlElement) {
            return;
        }

        htmlElement.style.overscrollBehavior = open ? 'none' : 'auto';
        htmlElement.style.overflow = open ? 'hidden' : 'auto';
        return () => {
            htmlElement.style.overscrollBehavior = 'auto';
            htmlElement.style.overflow = 'auto';
        };
    }, [open, lockScroll]);
};
